import { ConceptCategory, Difficulty, Language } from '../types';

// === Concept Translations ===
export const CONCEPT_TRANSLATIONS: Record<Language, Record<string, string>> = {
  [Language.FRENCH]: {
    // These are the original French labels from CONCEPT_LABELS
    'Types de données (int, string, bool, float, Vector3, arrays, List<T>)': 'Types de données (int, string, bool, float, Vector3, arrays, List<T>)',
    'Déclaration, initialisation et assignation de variables': 'Déclaration, initialisation et assignation de variables',
    'Modificateurs d\'accès (public, private, [SerializeField])': 'Modificateurs d\'accès (public, private, [SerializeField])',
    'Signatures de méthodes (void, string, IEnumerator, paramètres)': 'Signatures de méthodes (void, string, IEnumerator, paramètres)',
    'Opérateurs (arithmétiques, comparaison, logiques, incrémentation)': 'Opérateurs (arithmétiques, comparaison, logiques, incrémentation)',
    'Instructions conditionnelles (if, else if, else)': 'Instructions conditionnelles (if, else if, else)',
    'Boucles (for, foreach)': 'Boucles (for, foreach)',
    'Énumérations et instructions switch': 'Énumérations et instructions switch',
    'Commentaires et documentation': 'Commentaires et documentation',
    'Identification d\'erreurs courantes': 'Identification d\'erreurs courantes',
    'Conventions de nommage (PascalCase)': 'Conventions de nommage (PascalCase)',
    'Cycle de vie MonoBehaviour (Awake, Start, Update, etc.)': 'Cycle de vie MonoBehaviour (Awake, Start, Update, etc.)',
    'Gestion des entrées (Input.GetKey, Input.GetMouseButton, etc.)': 'Gestion des entrées (Input.GetKey, Input.GetMouseButton, etc.)',
    'Manipulation GameObject (tags, Instantiate, Destroy)': 'Manipulation GameObject (tags, Instantiate, Destroy)',
    'Accès aux composants (GetComponent<T>)': 'Accès aux composants (GetComponent<T>)',
    'Physique 2D (Rigidbody2D) et détection collision/trigger': 'Physique 2D (Rigidbody2D) et détection collision/trigger',
    'Mathématiques vectorielles (Vector3, Random.Range, Time.deltaTime)': 'Mathématiques vectorielles (Vector3, Random.Range, Time.deltaTime)',
    'Coroutines (IEnumerator, StartCoroutine, yield)': 'Coroutines (IEnumerator, StartCoroutine, yield)',
    'Système d\'animation (Animator interactions)': 'Système d\'animation (Animator interactions)',
    'Interaction UI de base (TextMeshProUGUI, boutons)': 'Interaction UI de base (TextMeshProUGUI, boutons)',
    'Débogage (Debug.Log)': 'Débogage (Debug.Log)',
    'Classes abstraites (abstract class, méthodes abstract, override)': 'Classes abstraites (abstract class, méthodes abstract, override)',
    'Interfaces C# (interface, implémentation par une classe)': 'Interfaces C# (interface, implémentation par une classe)',
    // Python/JS concepts
    'Affichage (print / console.log)': 'Affichage (print / console.log)',
    'Saisie utilisateur (input / prompt)': 'Saisie utilisateur (input / prompt)',
    'Manipulation de chaînes de caractères': 'Manipulation de chaînes de caractères',
    'Listes et tableaux': 'Listes et tableaux',
    'Dictionnaires / Objets': 'Dictionnaires / Objets',
    'Conversion de types': 'Conversion de types',
    // Godot GDScript concepts
    'Affichage console Godot (print)': 'Affichage console Godot (print)',
    'Tableaux (Array) et Dictionnaires GDScript': 'Tableaux (Array) et Dictionnaires GDScript',
    'Nodes et Scènes (get_node, $, @onready, @export)': 'Nodes et Scènes (get_node, $, @onready, @export)',
    'Cycle de vie Godot (_ready, _process, delta)': 'Cycle de vie Godot (_ready, _process, delta)',
    'Signaux (signal, emit, connect)': 'Signaux (signal, emit, connect)',
    'Await, Callable et callbacks': 'Await, Callable et callbacks',
    'GDScript typé et mots-clés avancés (class_name, match, enum)': 'GDScript typé et mots-clés avancés (class_name, match, enum)',
    'Maths vectorielles (Vector2, normalized, lerp)': 'Maths vectorielles (Vector2, normalized, lerp)',
    'Instanciation de scènes (preload, instantiate, add_child)': 'Instanciation de scènes (preload, instantiate, add_child)',
    'Mouvement de personnage (CharacterBody2D, velocity, move_and_slide)': 'Mouvement de personnage (CharacterBody2D, velocity, move_and_slide)',
    'POO et patterns GDScript (héritage, set/get, Resources, state machines)': 'POO et patterns GDScript (héritage, set/get, Resources, state machines)'
  },
  [Language.ENGLISH]: {
    // English translations of the concept labels
    'Types de données (int, string, bool, float, Vector3, arrays, List<T>)': 'Data types (int, string, bool, float, Vector3, arrays, List<T>)',
    'Déclaration, initialisation et assignation de variables': 'Variable declaration, initialization and assignment',
    'Modificateurs d\'accès (public, private, [SerializeField])': 'Access modifiers (public, private, [SerializeField])',
    'Signatures de méthodes (void, string, IEnumerator, paramètres)': 'Method signatures (void, string, IEnumerator, parameters)',
    'Opérateurs (arithmétiques, comparaison, logiques, incrémentation)': 'Operators (arithmetic, comparison, logical, increment)',
    'Instructions conditionnelles (if, else if, else)': 'Conditional statements (if, else if, else)',
    'Boucles (for, foreach)': 'Loops (for, foreach)',
    'Énumérations et instructions switch': 'Enumerations and switch statements',
    'Commentaires et documentation': 'Comments and documentation',
    'Identification d\'erreurs courantes': 'Common error identification',
    'Conventions de nommage (PascalCase)': 'Naming conventions (PascalCase)',
    'Cycle de vie MonoBehaviour (Awake, Start, Update, etc.)': 'MonoBehaviour lifecycle (Awake, Start, Update, etc.)',
    'Gestion des entrées (Input.GetKey, Input.GetMouseButton, etc.)': 'Input handling (Input.GetKey, Input.GetMouseButton, etc.)',
    'Manipulation GameObject (tags, Instantiate, Destroy)': 'GameObject manipulation (tags, Instantiate, Destroy)',
    'Accès aux composants (GetComponent<T>)': 'Component access (GetComponent<T>)',
    'Physique 2D (Rigidbody2D) et détection collision/trigger': '2D physics (Rigidbody2D) and collision/trigger detection',
    'Mathématiques vectorielles (Vector3, Random.Range, Time.deltaTime)': 'Vector mathematics (Vector3, Random.Range, Time.deltaTime)',
    'Coroutines (IEnumerator, StartCoroutine, yield)': 'Coroutines (IEnumerator, StartCoroutine, yield)',
    'Système d\'animation (Animator interactions)': 'Animation system (Animator interactions)',
    'Interaction UI de base (TextMeshProUGUI, boutons)': 'Basic UI interaction (TextMeshProUGUI, buttons)',
    'Débogage (Debug.Log)': 'Debugging (Debug.Log)',
    'Classes abstraites (abstract class, méthodes abstract, override)': 'Abstract classes (abstract class, abstract methods, override)',
    'Interfaces C# (interface, implémentation par une classe)': 'C# interfaces (interface, implementation by a class)',
    // Python/JS concepts
    'Affichage (print / console.log)': 'Output (print / console.log)',
    'Saisie utilisateur (input / prompt)': 'User input (input / prompt)',
    'Manipulation de chaînes de caractères': 'String manipulation',
    'Listes et tableaux': 'Lists and arrays',
    'Dictionnaires / Objets': 'Dictionaries / Objects',
    'Conversion de types': 'Type conversion',
    // Godot GDScript concepts
    'Affichage console Godot (print)': 'Godot console output (print)',
    'Tableaux (Array) et Dictionnaires GDScript': 'GDScript Arrays and Dictionaries',
    'Nodes et Scènes (get_node, $, @onready, @export)': 'Nodes and Scenes (get_node, $, @onready, @export)',
    'Cycle de vie Godot (_ready, _process, delta)': 'Godot lifecycle (_ready, _process, delta)',
    'Signaux (signal, emit, connect)': 'Signals (signal, emit, connect)',
    'Await, Callable et callbacks': 'Await, Callable and callbacks',
    'GDScript typé et mots-clés avancés (class_name, match, enum)': 'Typed GDScript and advanced keywords (class_name, match, enum)',
    'Maths vectorielles (Vector2, normalized, lerp)': 'Vector math (Vector2, normalized, lerp)',
    'Instanciation de scènes (preload, instantiate, add_child)': 'Scene instancing (preload, instantiate, add_child)',
    'Mouvement de personnage (CharacterBody2D, velocity, move_and_slide)': 'Character movement (CharacterBody2D, velocity, move_and_slide)',
    'POO et patterns GDScript (héritage, set/get, Resources, state machines)': 'GDScript OOP and patterns (inheritance, set/get, Resources, state machines)'
  }
};

// === Topic Translations ===
export const TOPIC_TRANSLATIONS: Record<Language, Record<string, string>> = {
  [Language.FRENCH]: {
    'Variables et Types': 'Variables et Types',
    'Opérateurs': 'Opérateurs',
    'Logique Conditionnelle': 'Logique Conditionnelle',
    'Boucles': 'Boucles',
    'Méthodes': 'Méthodes',
    'Classes et Objets': 'Classes et Objets',
    'Unity Basics': 'Unity Basics',
    'GameObjects': 'GameObjects',
    'Components': 'Components',
    'Input System': 'Input System',
    'Physics': 'Physics',
    'Animation': 'Animation',
    'UI System': 'UI System'
  },
  [Language.ENGLISH]: {
    'Variables et Types': 'Variables and Types',
    'Opérateurs': 'Operators',
    'Logique Conditionnelle': 'Conditional Logic',
    'Boucles': 'Loops',
    'Méthodes': 'Methods',
    'Classes et Objets': 'Classes and Objects',
    'Unity Basics': 'Unity Basics',
    'GameObjects': 'GameObjects',
    'Components': 'Components',
    'Input System': 'Input System',
    'Physics': 'Physics',
    'Animation': 'Animation',
    'UI System': 'UI System'
  }
};

// === Difficulty Axis Translations ===
export const DIFFICULTY_AXIS_TRANSLATIONS: Record<Language, Record<string, string>> = {
  [Language.FRENCH]: {
    'Débutant': 'Débutant',
    'Intermédiaire': 'Intermédiaire',
    'Avancé': 'Avancé',
    'Séquentiel': 'Séquentiel',
    'Basique': 'Basique',
    'Fondamental': 'Fondamental',
    'Courant': 'Courant',
    'Spécifique': 'Spécifique',
    'Une Ligne': 'Une Ligne',
    'Une Fonction': 'Une Fonction',
    'Un Composant': 'Un Composant',
    'Interaction': 'Interaction',
    'Un Seul': 'Un Seul',
    'Quelques-uns': 'Quelques-uns',
    'Intégré': 'Intégré'
  },
  [Language.ENGLISH]: {
    'Débutant': 'Beginner',
    'Intermédiaire': 'Intermediate',
    'Avancé': 'Advanced',
    'Séquentiel': 'Sequential',
    'Basique': 'Basic',
    'Fondamental': 'Fundamental',
    'Courant': 'Common',
    'Spécifique': 'Specific',
    'Une Ligne': 'One Line',
    'Une Fonction': 'One Function',
    'Un Composant': 'One Component',
    'Interaction': 'Interaction',
    'Un Seul': 'Single One',
    'Quelques-uns': 'Few',
    'Intégré': 'Integrated'
  }
};

// === Educational Terms ===
export const EDUCATIONAL_TERMS: Record<Language, Record<string, string>> = {
  [Language.FRENCH]: {
    'exercice': 'exercice',
    'solution': 'solution',
    'correction': 'correction',
    'feedback': 'feedback',
    'réussite': 'réussite',
    'échec': 'échec',
    'progression': 'progression',
    'concept': 'concept',
    'compétence': 'compétence',
    'apprentissage': 'apprentissage'
  },
  [Language.ENGLISH]: {
    'exercice': 'exercise',
    'solution': 'solution',
    'correction': 'correction',
    'feedback': 'feedback',
    'réussite': 'success',
    'échec': 'failure',
    'progression': 'progress',
    'concept': 'concept',
    'compétence': 'skill',
    'apprentissage': 'learning'
  }
};

// === Feedback Messages ===
export const FEEDBACK_TRANSLATIONS: Record<Language, Record<string, string>> = {
  [Language.FRENCH]: {
    'Excellent travail !': 'Excellent travail !',
    'Bon travail !': 'Bon travail !',
    'Peut mieux faire': 'Peut mieux faire',
    'À retravailler': 'À retravailler',
    'Erreur de compilation': 'Erreur de compilation',
    'Logique correcte': 'Logique correcte',
    'Logique incorrecte': 'Logique incorrecte',
    'Bonnes pratiques': 'Bonnes pratiques',
    'À améliorer': 'À améliorer'
  },
  [Language.ENGLISH]: {
    'Excellent travail !': 'Excellent work!',
    'Bon travail !': 'Good work!',
    'Peut mieux faire': 'Could be better',
    'À retravailler': 'Needs rework',
    'Erreur de compilation': 'Compilation error',
    'Logique correcte': 'Correct logic',
    'Logique incorrecte': 'Incorrect logic',
    'Bonnes pratiques': 'Good practices',
    'À améliorer': 'Needs improvement'
  }
};

// === Helper Functions ===

/**
 * Get a general translation for any term
 */
export function getTranslation(key: string, language: Language): string {
  // Try concept translations first
  if (CONCEPT_TRANSLATIONS[language] && CONCEPT_TRANSLATIONS[language][key]) {
    return CONCEPT_TRANSLATIONS[language][key];
  }
  
  // Try topic translations
  if (TOPIC_TRANSLATIONS[language] && TOPIC_TRANSLATIONS[language][key]) {
    return TOPIC_TRANSLATIONS[language][key];
  }
  
  // Try difficulty translations
  if (DIFFICULTY_AXIS_TRANSLATIONS[language] && DIFFICULTY_AXIS_TRANSLATIONS[language][key]) {
    return DIFFICULTY_AXIS_TRANSLATIONS[language][key];
  }
  
  // Try educational terms
  if (EDUCATIONAL_TERMS[language] && EDUCATIONAL_TERMS[language][key]) {
    return EDUCATIONAL_TERMS[language][key];
  }
  
  // Try feedback translations
  if (FEEDBACK_TRANSLATIONS[language] && FEEDBACK_TRANSLATIONS[language][key]) {
    return FEEDBACK_TRANSLATIONS[language][key];
  }
  
  // Fallback: return original key
  console.warn(`Translation key not found: ${key}`);
  return key;
}

/**
 * Get concept label translation
 */
export function getConceptLabel(concept: string, language: Language): string {
  return CONCEPT_TRANSLATIONS[language]?.[concept] || concept;
}

/**
 * Get topic name translation
 */
export function getTopicName(topic: string, language: Language): string {
  return TOPIC_TRANSLATIONS[language]?.[topic] || topic;
}

/**
 * Get difficulty level translation
 */
export function getDifficultyLevel(difficulty: Difficulty | string, language: Language): string {
  const difficultyString = typeof difficulty === 'string' ? difficulty : String(difficulty);
  return DIFFICULTY_AXIS_TRANSLATIONS[language]?.[difficultyString] || difficultyString;
}

/**
 * Get educational term translation
 */
export function getEducationalTerm(term: string, language: Language): string {
  return EDUCATIONAL_TERMS[language]?.[term] || term;
}

/**
 * Get feedback message translation
 */
export function getFeedbackMessage(message: string, language: Language): string {
  return FEEDBACK_TRANSLATIONS[language]?.[message] || message;
}

/**
 * Translate an array of concepts
 */
export function translateConcepts(concepts: string[], language: Language): string[] {
  return concepts.map(concept => getConceptLabel(concept, language));
}

/**
 * Check if a translation exists for a key
 */
export function hasTranslation(key: string, language: Language): boolean {
  return !!(
    CONCEPT_TRANSLATIONS[language]?.[key] ||
    TOPIC_TRANSLATIONS[language]?.[key] ||
    DIFFICULTY_AXIS_TRANSLATIONS[language]?.[key] ||
    EDUCATIONAL_TERMS[language]?.[key] ||
    FEEDBACK_TRANSLATIONS[language]?.[key]
  );
}
